import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Loader from "../components/Loader";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";

const SHOP_POINTS = [
  {
    id: 1,
    name: "50$",
    price: 100,
  },
  {
    id: 2,
    name: "10 RANDOM CC USA",
    price: 120,
  },
  {
    id: 3,
    name: "10 RANDOM CC MIX",
    price: 150,
  },
  {
    id: 4,
    name: "110$",
    price: 200,
  },
  {
    id: 5,
    name: "1250$",
    price: 1500,
  },
];

function ShopPoints() {
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="page" style={{ visibility: "visible", opacity: 1 }}>
      <div className="page-main is-expanded">

        {/* HEADER */}
        <Header
          onToggleSidebar={() => setMobileMenuOpen(o => !o)}
        />

        {/* SIDEBAR */}
        <Sidebar
          mobileOpen={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          active="shop-points"
        />

        {/* CONTENT */}
        <div className="app-content main-content mt-0">
          <div className="side-app">
            <div className="main-container container-fluid">

              {/* PAGE HEADER */}
              <div className="page-header">
                <div>
                  <h1 className="page-title">SHOP points</h1>
                </div>

                <div className="ms-auto pageheader-btn">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/wallet">Home</a>
                    </li>

                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      SHOP points
                    </li>
                  </ol>
                </div>
              </div>

              {/* SHOP POINTS */}
              <div className="row">
                <div className="col-md-12">

                  <div className="row">
                    {SHOP_POINTS.map((item) => (
                      <div className="col-md-4" key={item.id}>
                        <div className="card">

                          <div className="card-header border-bottom d-block text-center">
                            <h4>{item.name}</h4>
                            <p>Price: {item.price} Points</p>
                          </div>

                          <div className="card-body">
                            <button
                              type="button"
                              disabled
                              className="btn btn-primary btn-block"
                            >
                              Buy
                            </button>
                          </div>

                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="footer">
          <div className="container">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-md-12 col-sm-12 text-center">
                Copyright Patrick Market © 2025 All rights reserved
              </div>
            </div>
          </div>
        </footer>

      </div>
    </div>
  );
}

export default ShopPoints;